import React from "react";
import brandIcon from "../assets/brand-icon.png";
import { useLanguage } from "../lib/language";

function BrandLogo({ compact = false, light = false }) {
  const { t } = useLanguage();

  return (
    <div className={compact ? "brand-mark brand-mark--compact" : "brand-mark"}>
      <div className={light ? "brand-mark__badge brand-mark__badge--light" : "brand-mark__badge"}>
        <img src={brandIcon} alt={t("brandTitle")} className="brand-mark__image" />
      </div>
      <div className="brand-mark__text">
        <p className={light ? "brand-mark__eyebrow brand-mark__eyebrow--light" : "brand-mark__eyebrow"}>
          {t("platformEyebrow")}
        </p>
        <h1 className={compact ? "brand-mark__title brand-mark__title--compact" : "brand-mark__title"}>
          {t("brandTitle")}
        </h1>
      </div>
    </div>
  );
}

export default BrandLogo;
